import swal from "sweetalert";
import {
    Dropdown
} from "react-bootstrap";

const SweetAlertButton = ({isSuccess,icon,bodyMsg,cancelMsg,okMsg,actionFunc}) => {
    return (
    <i
        className={icon}
        style={{color:'red'}}
        aria-hidden="true"
        onClick={() =>
            swal({
                title: "Are you sure?",
                text: bodyMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    actionFunc()
                } else {
                    swal(cancelMsg,{
                        icon:"error"
                    });
                }
            })
        }
    >


    </i>
    );
};

export default SweetAlertButton;
